import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import type { Codeable, ColumnNames } from 'modules/app_store/pages/SettingsPage/Apps/common/types'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import Table from 'modules/payroll_integrations/components/Table'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'

import PayrollPaywallGuard from '../../PayrollPaywallGuard'

const DatevIntegration = () => {
  const INTEGRATION_NAME = PayrollIntegration.datev

  const COLUMN_NAMES: ColumnNames = [
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev.settings.form.header.concept'
      ),
      colSpan: 4,
      attribute: 'concept',
    },
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev.settings.form.header.value'
      ),
      colSpan: 4,
      attribute: 'value',
    },
  ]

  const codeables: Record<string, Codeable> = {
    company: {
      position: 0,
      collection: [companies.current],
      class: 'Company',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev.settings.form.concept.company'
      ),
    },
    bookkeper: {
      position: 1,
      collection: [companies.current],
      class: 'Bookkeper',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev.settings.form.concept.bookkeper'
      ),
    },
    valid_from: {
      position: 2,
      collection: [companies.current],
      class: 'ValidFrom',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev.settings.form.concept.valid_from'
      ),
    },
  }

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body variant="full">
        <Table columnNames={COLUMN_NAMES} codeables={codeables} integration={INTEGRATION_NAME} />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default DatevIntegration
